import { CardPaymentProviderName, Currency, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';

export abstract class AbstractSinglePaymentMethod extends AbstractPaymentMethod {
  protected abstract ALLOWED_PAYMENT_METHOD_TYPES: PaymentMethodType[];

  public setup(amount: number, currency: Currency): void {
    this.amount = amount;
    this.currency = currency;
    this.isSetup = true;
  }

  public getAllProviderNames(): CardPaymentProviderName[] {
    return [CardPaymentProviderName.COMERCIA]; //TODO => Hardcoded, fix when available
  }

  public areOptionsConfigurable(): boolean {
    return false;
  }
}
